import { types } from '../../../constants/ActionTypes'
import { boardType, defaultInsertStrings } from '../../../constants'
import * as constants from '../../../constants'
import { deepCopy, strToRenjuBoardCard, objectSort, judgePuzzleTurn, deleteUndefinedProps } from '../../../lib'
import { initialSettings } from '../../../constants'
import RenjuEngine from '../../../lib/RenjuEngine'
import FiveMovesValidator from '../../../lib/FiveMovesValidator';

const initialMove = {
  x: null,
  y: null,
  color: null,
  number: 0,
  marks: [],
  insertStrings: constants.defaultInsertStrings,
}

const initialGameInfo = {
  openingRule: constants.OPENING_RULE.NONE,
  title: '',
  blackPlayerName: '',
  whitePlayerName: '',
  gameEndNumber: '',
  gameResult: '',
  soosyrv8: {
    swap1: undefined,
    swap2: undefined,
    fiveMoveNumber: 0,
    fiveMoves: [],
  }
}

const initialPuzzleInfo = {
  stoneType: constants.stoneType.BLACK,
  selectedTurn: constants.turnType.AUTO,
  turn: constants.turnType.BLACK,
  level: '',
  type: '',
}

const initialCard = {
  type: '',
  editMode: constants.editModeType.NORMAL,
  operationMode: constants.operationModeType.EDIT,
  isAnalyzeMode: false,
  isMarkMode: false,
  isPlayMode: false,
  intervalId: -1,
  moves: [deepCopy(initialMove)],
  movesHistory: [deepCopy(initialMove)],
  movesAnalyze: [deepCopy(initialMove)],
  forbiddenPosition: [],
  analyzeStartNum: 0,
  scale: 1,
  isSpecifiedWidth: false,
  cardWidth: 0,
  boardWidth: 0,
  settings: {},
  gameInfo: deepCopy(initialGameInfo),
  message: {
    visible: false,
    type: constants.renjuBoardMessageType.NONE,
  }
}

const initialWebBoardCard = {
  ...deepCopy(initialCard),
  type: boardType.WEB_BOARD,
  puzzleInfo: deepCopy(initialPuzzleInfo),
  settings: deepCopy(initialSettings),
  gameInfo: deepCopy(initialGameInfo),
}

const initialLiveGameCard = {
  ...deepCopy(initialCard),
  type: boardType.LIVE_GAME,
  operationMode: constants.operationModeType.VIEW,
  settings: deepCopy(initialSettings),
  gameInfo: deepCopy(initialGameInfo),
  live: {
    status: 0,
    liveId: '',
    contributor: null,
    moves: [deepCopy(initialMove)],
    movesHistory: [deepCopy(initialMove)],
    movesAnalyze: [deepCopy(initialMove)],
    analyzeStartNum: 0,
    isAnalyzeMode: false,
    settings: {
      isVisibleGameInfo: true,
      isVisibleTitle: true,
      isVisiblePlayerName: true,
      isVisibleGameResult: true,
    },
    gameInfo: deepCopy(initialGameInfo),
  },
}

const initialGameRoomCard = {
  ...deepCopy(initialCard),
  type: boardType.GAME_ROOM,
}

const initialPuzzleRegisterCard = {
  ...deepCopy(initialWebBoardCard),
  type: boardType.PUZZLE_REGISTER,
  operationMode: constants.operationModeType.EDIT,
  editMode: constants.editModeType.PUZZLE,
}

const initialPuzzleViewerCard = {
  ...deepCopy(initialWebBoardCard),
  type: boardType.PUZZLE_VIEWER,
  operationMode: constants.operationModeType.SET,
  editMode: constants.editModeType.PUZZLE,
}

const initialGameAnalyzeCard = {
  ...deepCopy(initialCard),
  type: boardType.GAME_ANALYZE,
  operationMode: constants.operationModeType.EDIT,
  settings: deepCopy(initialSettings),
  gameInfo: deepCopy(initialGameInfo),
  live: {
    liveId: '',
  }
}

const initialState = {
  path: '',
  cards: [],
  boardSettings: {
    isVisibleNumber: true,
    isVisibleNextMove: true,
    isVisibleForbidden: true,
    isVisibleLastMoveMark: true,
  }
}

const RenjuBoardCards = (state = initialState, action) => {
  var newState, card, newCard, record, index, boardSettings
  newState = deepCopy(state)
  if (action.bid !== undefined && newState.cards[action.bid]) {
    card = newState.cards[action.bid]
  }
  switch (action.type) {

    case types.router.LOCATION_CHANGE:
      newState.cards.forEach((card) => {
        if (card.intervalId >= 0) {
          card.isPlayMode = false
          clearInterval(card.intervalId)
          card.intervalId = -1
        }
      })

      let params = action.payload.location.pathname.split('/')
      let regstr = Object.keys(constants.LANGUAGE_SHORT_CODE).map(key => `^${constants.LANGUAGE_SHORT_CODE[key]}$`).join('|')
      let pathname
      if (null !== params[1].match(`/${regstr}/`)) {
        params.splice(1,1)
        pathname = params.join('/')
      }
      else {
        pathname = action.payload.location.pathname
      }
      if (pathname === state.path) {
        return { ...state, path: pathname }
      }
      else {
        newState.cards = newState.cards.filter((card) => card.type === constants.boardType.WEB_BOARD)
      }
      newState.path = pathname

      return newState

    // board
    case types.webBoard.INIT:
      if (!newState.cards.some((card) => card.type === constants.boardType.WEB_BOARD)) {
        newState.cards.push(deepCopy(initialWebBoardCard))
        if (Object.keys(action.urlParams).some((key) => key !== undefined)) {
          if (
            action.urlParams.moves !== undefined &&
            Object.keys(action.urlParams).filter((key) => 
              typeof(action.urlParams[key]) !== 'function' &&
              action.urlParams[key] !== undefined
            ).length === 1
          ) {
            init(newState, action.boardType, convertMoves(action.urlParams.moves))
          }
          else {
            init(newState, action.boardType, action.urlParams, action.liveId)
          }
        }
      }
      
      return newState
    case types.webBoard.REFRESH:
      index = newState.cards.findIndex((card) => card.type === constants.boardType.WEB_BOARD)
      if (index < 0) {
        return state
      }
      newState.cards[index] = deepCopy(initialWebBoardCard)
      resizeBoard(newState)
      return newState

    // storeBoardCard
    case types.storeBoardCard.recordMenu.EDIT:
      index = newState.cards.findIndex((card) => card.type === constants.boardType.WEB_BOARD)
      if (index < 0) {
        return state
      }
      newState.cards[index] = {
        ...deepCopy(initialWebBoardCard),
        ...action.boardContext,
        settings: {
          ...deepCopy(initialWebBoardCard.settings),
          ...action.boardContext.settings,
        },
        gameInfo: {
          ...deepCopy(initialWebBoardCard.gameInfo),
          ...action.boardContext.gameInfo,
        },
        puzzleInfo: {
          ...deepCopy(initialWebBoardCard.puzzleInfo),
          ...action.boardContext.puzzleInfo,
        }
      }
      setForbiddenPosition(newState.cards[index])
      resizeBoard(newState)
      return newState

    // renjuBoardCard
    case types.renjuBoardCard.RESIZE_BOARD:
      resizeBoard(newState)
      return newState
    case types.renjuBoardCard.CLOSE:
      delete newState.cards[action.bid]
      return newState
    case types.renjuBoardCard.ANALYZE_MODE_ON:
      card.isAnalyzeMode = true
      card.analyzeStartNum = card.moves.length - 1
      card.movesAnalyze = deepCopy(card.moves)
      return newState
    case types.renjuBoardCard.ANALYZE_MODE_OFF:
      card.isAnalyzeMode = false
      card.moves = card.moves.slice(0, card.analyzeStartNum + 1)
      card.movesAnalyze = []
      card.analyzeStartNum = 0
      setForbiddenPosition(card)
      return newState
    case types.renjuBoardCard.MARK_MODE_ON:
      card.isMarkMode = true
      return newState
    case types.renjuBoardCard.MARK_MODE_OFF:
      card.isMarkMode = false
      return newState
    case types.renjuBoardCard.REMOVE_MARK:
      removeMark(card)
      return newState
    case types.renjuBoardCard.CHANGED_INSERT_STRINGS:
      if (
        card.editMode === constants.editModeType.PUZZLE &&
        card.operationMode === constants.operationModeType.EDIT
      ) {
        card.moves[0].insertStrings = action.insertStrings  
      }
      card.moves[card.moves.length - 1].insertStrings = action.insertStrings
      return newState
    case types.renjuBoardCard.SELECTED_EDIT_MODE:
      if (
        card.editMode === constants.editModeType.NORMAL &&
        action.selectedIndex === constants.editModeType.PUZZLE
      ){
        card.operationMode = constants.operationModeType.EDIT
        card.isAnalyzeMode = false
        card.isMarkMode = false
        card.moves =
          card.moves
          .filter((move, index) => { return (index === 0 || ( move.x !== null && move.y !== null )) })
          .map(move => { return { ...move, number: 0, marks: [], insertStrings: constants.defaultInsertStrings } })
        card.movesHistory = [deepCopy(initialMove)]
        card.movesAnalyze = [deepCopy(initialMove)]
      }
      if (
        card.editMode === constants.editModeType.PUZZLE &&
        action.selectedIndex === constants.editModeType.NORMAL
      ){
        card.operationMode = constants.operationModeType.EDIT
        card.moves = [deepCopy(initialMove)]
        card.movesHistory = [deepCopy(initialMove)]
        card.movesAnalyze = [deepCopy(initialMove)]
      }
      card.editMode = action.selectedIndex
      return newState
    case types.renjuBoardCard.SELECTED_OPERATION_MODE:
      switch (card.editMode) {
        case constants.editModeType.NORMAL:
          if (
            card.type === boardType.LIVE_GAME && 
            card.operationMode === constants.operationModeType.EDIT &&
            action.selectedIndex === constants.operationModeType.VIEW
          ) {
            card.moves           = card.live.moves           ? deepCopy(card.live.moves) : [deepCopy(initialMove)]
            card.movesHistory    = card.live.movesHistory    ? deepCopy(card.live.movesHistory) : [deepCopy(initialMove)]
            card.movesAnalyze    = card.live.movesAnalyze    ? deepCopy(card.live.movesAnalyze) : [deepCopy(initialMove)]
            card.analyzeStartNum = card.live.analyzeStartNum ? card.live.analyzeStartNum : 0
            card.isAnalyzeMode   = card.live.isAnalyzeMode   ? card.live.isAnalyzeMode : false
            card.gameInfo.title           = card.live.gameInfo.title           ? card.live.gameInfo.title : ''
            card.gameInfo.blackPlayerName = card.live.gameInfo.blackPlayerName ? card.live.gameInfo.blackPlayerName : ''
            card.gameInfo.whitePlayerName = card.live.gameInfo.whitePlayerName ? card.live.gameInfo.whitePlayerName : ''
            card.gameInfo.gameEndNumber   = card.live.gameInfo.gameEndNumber   ? card.live.gameInfo.gameEndNumber : ''
            card.gameInfo.gameResult      = card.live.gameInfo.gameResult      ? card.live.gameInfo.gameResult : ''
          }
          break
        case constants.editModeType.PUZZLE:
          if (
            card.operationMode === constants.operationModeType.SET &&
            action.selectedIndex === constants.operationModeType.EDIT
          ) {
            card.moves = card.moves.filter((move) => move.number === 0)
            card.movesHistory = [deepCopy(initialMove)]
            card.movesAnalyze = [deepCopy(initialMove)]
          }
          else if (
            card.operationMode === constants.operationModeType.EDIT &&
            action.selectedIndex === constants.operationModeType.SET
          ) {
            card.moves[card.moves.length - 1].marks = deepCopy(card.moves[0].marks)
            card.moves[card.moves.length - 1].insertStrings = card.moves[0].insertStrings
            card.movesHistory = deepCopy(card.moves)
            card.movesAnalyze = deepCopy(card.moves)

            if (card.puzzleInfo.selectedTurn === constants.turnType.AUTO) {
              card.puzzleInfo.turn = judgePuzzleTurn(card)
            }
            else {
              card.puzzleInfo.turn = card.puzzleInfo.selectedTurn
            }
          }
          break
        default:
          break
      }
      card.operationMode = action.selectedIndex
      return newState
    case types.renjuBoardCard.SELECTED_TURN_MENU:
      card.puzzleInfo.selectedTurn = action.selectedIndex
      return newState
    case types.renjuBoardCard.CHANGED_STONE_TYPE:
      card.puzzleInfo.stoneType = action.stoneType
      return newState
    case types.renjuBoardCard.CHANGED_GAME_INFO:
      if (card.gameInfo.openingRule !== action.gameInfo.openingRule) {
        card.moves = [deepCopy(initialMove)]
        card.movesHistory = [deepCopy(initialMove)]
        card.movesAnalyze = [deepCopy(initialMove)]
      }
      card.gameInfo = { ...card.gameInfo, ...action.gameInfo }
      return newState
    case types.renjuBoardCard.CHANGED_PUZZLE_INFO:
      card.puzzleInfo = { ...card.puzzleInfo, ...action.puzzleInfo }
      return newState
    case types.renjuBoardCard.CHANGED_SETTINGS:
      card.settings = action.settings
      if (action.settings.isVisibleForbidden === true) {
        setForbiddenPosition(card)
      }
      return newState
    case types.renjuBoardCard.CLICK_RENJU_BOARD:
      clickRenjuBoard(action.bid, action.event, card)
      return newState
    case types.renjuBoardCard.RIGHT_CLICK_RENJU_BOARD:
      rightClickRenjuBoard(action.bid, action.event, card)
      return newState
    case types.renjuBoardCard.SPECIFIED_WIDTH_ON:
      card.isSpecifiedWidth = true
      return newState
    case types.renjuBoardCard.SPECIFIED_WIDTH_OFF:
      card.isSpecifiedWidth = false
      return newState
    case types.renjuBoardCard.CHANGED_SWAP:
      switch (card.gameInfo.openingRule) {
        case constants.OPENING_RULE.SOOSYRV8:
          if (card.moves.length === 4) {
            card.gameInfo.soosyrv8.swap1 = action.swap
            addMove(card, { swap: card.gameInfo.soosyrv8.swap1, x: null, y: null, color: null, number: 0, marks: [], insertStrings: defaultInsertStrings }, ['swap'])
          }
          if (card.moves.length === 7) {
            card.gameInfo.soosyrv8.swap2 = action.swap
            addMove(card, { swap: card.gameInfo.soosyrv8.swap2, x: null, y: null, color: null, number: 0, marks: [], insertStrings: defaultInsertStrings }, ['swap'])
          }
          break
        default:
          break
      }
      return newState
    case types.renjuBoardCard.CHANGED_FIVE_MOVE_NUMBER:
      switch (card.gameInfo.openingRule) {
        case constants.OPENING_RULE.SOOSYRV8:
          card.gameInfo.soosyrv8.fiveMoveNumber = parseInt(action.value, 10)
          break
        default:
          break
      }
      return newState
    case types.renjuBoardCard.DECISION: 
      switch (action.decisionType) {
        case constants.decisionType.SOOSYRV8_SWAP1:
          if (
            card.moves.length !== 4 ||
            card.gameInfo.soosyrv8.swap1 === undefined
          ) {
            return newState
          }
          addMove(card, { swap: card.gameInfo.soosyrv8.swap1, x: null, y: null, color: null, number: 0, marks: [], insertStrings: defaultInsertStrings }, ['swap'])
          break
        case constants.decisionType.SOOSYRV8_FIVE_MOVE_NUMBER:
          if (card.moves.length !== 6) {
            return newState
          }
          addMove(card, { fiveMoveNumber: card.gameInfo.soosyrv8.fiveMoveNumber, x: null, y: null, color: null, number: 0, marks: [], insertStrings: defaultInsertStrings }, ['fiveMoveNumber'])
          break
        case constants.decisionType.SOOSYRV8_SWAP2:
          if (card.moves.length !== 7) {
            return newState
          }
          addMove(card, { swap: card.gameInfo.soosyrv8.swap2, x: null, y: null, color: null, number: 0, marks: [], insertStrings: defaultInsertStrings }, ['swap'])
          break
        case constants.decisionType.SOOSYRV8_FIVE_MOVES:
          if (card.moves.length !== 8){
            return newState
          }
          addMove(card, { fiveMoves: deepCopy(card.gameInfo.soosyrv8.fiveMoves), x: null, y: null, color: null, number: 0, marks: [], insertStrings: defaultInsertStrings }, ['fiveMoves'])
          break
        default:
          break
      }
      card.message.visible = false
      card.message.type = constants.renjuBoardMessageType.NONE
      return newState
    case types.renjuBoardCard.OPEN_MESSAGE:
      switch (card.gameInfo.openingRule) {
        case constants.OPENING_RULE.SOOSYRV8:
          if (card.moves.length === 4) {
            card.message.type = constants.renjuBoardMessageType.SWAP1
          }
          else if (card.moves.length === 6) {
            card.message.type = constants.renjuBoardMessageType.FIVE_MOVE_NUMBER
          }
          else if (card.moves.length === 7) {
            card.message.type = constants.renjuBoardMessageType.SWAP2
          }
          else if (card.moves.length === 8) {
            card.message.type = constants.renjuBoardMessageType.FIVE_MOVES
          }
          else {
            return newState
          }
          card.message.visible = true
          break
        default:
          break
      }
      return newState
    case types.renjuBoardCard.CLOSE_MESSAGE:
      card.message.visible = false
      return newState

    // socketIO
    case types.game.INITIALIZE: {
      newCard = {
        ...deepCopy(initialGameRoomCard),
        settings: {
          ...deepCopy(initialSettings),
          ...state.boardSettings,
          isVisibleNumber: false,
          isVisibleForbidden: false,
          isVisibleNextMove: false,
          isVisibleGameInfo: false
        },
        gameInfo: {
          ...deepCopy(initialGameInfo),
        },
        groupName: action.groupName, 
        roomName: action.roomName,
      }
      newState.cards.push(newCard)
      return newState
    }
    case types.game.RECEIVE_GAME_ROOM: {
      let gameCard
      let { room } = action.data
      gameCard = newState.cards.find(card => {
        return Boolean(
          card.groupName === room.groupName &&
          card.roomName === room.name
        )
      })
      if (gameCard !== undefined) {
        gameCard.moves = room.moves !== undefined ? room.moves.filter(move => move.invalid !== true) : gameCard.moves
        gameCard.movesHistory = room.moves !== undefined ? room.moves.filter(move => move.invalid !== true) : gameCard.movesHistory
        gameCard.gameInfo.openingRule = room.openingRule !== undefined ? room.openingRule : gameCard.gameInfo.openingRule
        gameCard.message.visible = false
        switch (gameCard.gameInfo.openingRule) {
          case constants.OPENING_RULE.SOOSYRV8:
            if (gameCard.moves.length === 1) {
              gameCard.gameInfo.soosyrv8 = deepCopy(initialGameInfo.soosyrv8)
            }
            gameCard.moves.forEach((move, index) => {
              if (index === 4) gameCard.gameInfo.soosyrv8.swap1 = move.swap
              if (index === 6) gameCard.gameInfo.soosyrv8.fiveMoveNumber = move.fiveMoveNumber
              if (index === 7) gameCard.gameInfo.soosyrv8.swap2 = move.swap
              if (index === 8) gameCard.gameInfo.soosyrv8.fiveMoves = move.fiveMoves
            })
            break
          default:
            break
        }
      }
      else {
        newCard = {
          ...deepCopy(initialGameRoomCard),
          settings: {
            ...deepCopy(initialSettings),
            ...state.boardSettings,
            isVisibleNumber: false,
            isVisibleForbidden: false,
            isVisibleNextMove: false,
            isVisibleGameInfo: false
          },
          gameInfo: {
            ...deepCopy(initialGameInfo),
            openingRule: room.openingRule,
          },
          groupName: room.groupName, 
          roomName: room.name,
        }
        newState.cards.push(newCard)
      }
      return newState
    }
    case types.live.INITIALIZE: {
      if (state.cards.some((card) => card.live && card.live.liveId === action.liveId)) {
        return newState
      }
      newCard = deepCopy(initialLiveGameCard)
      newCard.live.liveId = action.liveId
      newState.cards.push(newCard)
      return newState
    }
    case types.live.RECEIVE_LATEST_BOARD_CONTEXT:
    case types.live.RECEIVE_UPDATE_BOARD_CONTEXT:
      if (false === action.result){
        return newState
      }
      newCard = strToRenjuBoardCard({
        v: 2,
        mv: action.boardContext.mv,
        mk: action.boardContext.mk,
        an: action.boardContext.an,
        or: action.boardContext.or,
        sw: action.boardContext.sw,
        fn: action.boardContext.fn,
        fm: action.boardContext.fm,
        tl: action.boardContext.tl,
        bp: action.boardContext.bp,
        wp: action.boardContext.wp,
        gr: action.boardContext.gr
      })
      card = newState.cards.find(card => Boolean(card && card.live && card.live.liveId === action.liveId && card.type === boardType.LIVE_GAME))
      if (card){
        if (card.operationMode === constants.operationModeType.VIEW) {
          card.movesHistory = newCard.movesHistory ? deepCopy(newCard.movesHistory) : [deepCopy(initialMove)]
          card.movesAnalyze = newCard.movesAnalyze ? deepCopy(newCard.movesAnalyze) : [deepCopy(initialMove)]
          card.analyzeStartNum = newCard.analyzeStartNum ? newCard.analyzeStartNum : 0
          card.isAnalyzeMode = newCard.isAnalyzeMode ? newCard.isAnalyzeMode : false
          card.gameInfo.openingRule = newCard.gameInfo.openingRule ? newCard.gameInfo.openingRule : ''
          card.gameInfo.title = newCard.gameInfo.title ? newCard.gameInfo.title : ''
          card.gameInfo.blackPlayerName = newCard.gameInfo.blackPlayerName ? newCard.gameInfo.blackPlayerName : ''
          card.gameInfo.whitePlayerName = newCard.gameInfo.whitePlayerName ? newCard.gameInfo.whitePlayerName : ''
          card.gameInfo.gameEndNumber = newCard.gameInfo.gameEndNumber ? newCard.gameInfo.gameEndNumber : ''
          card.gameInfo.gameResult = newCard.gameInfo.gameResult ? newCard.gameInfo.gameResult : ''
          card.gameInfo.soosyrv8 = newCard.gameInfo.soosyrv8 ? deepCopy(newCard.gameInfo.soosyrv8) : deepCopy(constants.initialSoosyrv8)
          var json_live_moves = JSON.stringify(objectSort(card.live.moves))
          var json_current_moves = JSON.stringify(objectSort(card.moves))
          if (json_live_moves === json_current_moves || types.live.RECEIVE_LATEST_BOARD_CONTEXT) {
            card.moves = newCard.moves ? deepCopy(newCard.moves) : [deepCopy(initialMove)]
          }
          else {
            card.moves = newCard.moves ? deepCopy(newCard.moves.slice(0, card.moves.length)) : [deepCopy(initialMove)]
          }
        }
        card.live.moves = newCard.moves ? deepCopy(newCard.moves) : [deepCopy(initialMove)]
        card.live.movesHistory = newCard.movesHistory ? deepCopy(newCard.movesHistory) : [deepCopy(initialMove)]
        card.live.movesAnalyze = newCard.movesAnalyze ? deepCopy(newCard.movesAnalyze) : [deepCopy(initialMove)]
        card.live.analyzeStartNum = newCard.analyzeStartNum ? newCard.analyzeStartNum : 0
        card.live.isAnalyzeMode = newCard.isAnalyzeMode ? newCard.isAnalyzeMode : false
        card.live.gameInfo.openingRule = newCard.gameInfo.openingRule ? newCard.gameInfo.openingRule : ''
        card.live.gameInfo.title = newCard.gameInfo.title ? newCard.gameInfo.title : ''
        card.live.gameInfo.blackPlayerName = newCard.gameInfo.blackPlayerName ? newCard.gameInfo.blackPlayerName : ''
        card.live.gameInfo.whitePlayerName = newCard.gameInfo.whitePlayerName ? newCard.gameInfo.whitePlayerName : ''
        card.live.gameInfo.gameEndNumber = newCard.gameInfo.gameEndNumber ? newCard.gameInfo.gameEndNumber : ''
        card.live.gameInfo.gameResult = newCard.gameInfo.gameResult ? newCard.gameInfo.gameResult : ''
        card.live.gameInfo.soosyrv8 = newCard.gameInfo.soosyrv8 ? deepCopy(newCard.gameInfo.soosyrv8) : deepCopy(constants.initialSoosyrv8)
        if (action.contributor) {
          card.live.contributor = {
            displayName: action.contributor.displayName,
            photoURL: action.contributor.photoURL,
          } 
        }
        card.settings = { ...card.settings, ...state.boardSettings }
        setForbiddenPosition(card)
      }
      return newState
    case types.live.RECEIVE_USER_TYPE:
      for (card of newState.cards){
        if (!card || !card.live || card.live.liveId !== action.liveId) {
          continue
        }
        card.userType = action.userType
      }
      return newState
    case types.live.RECEIVE_LIVE_STATUS:
      for (card of newState.cards) {
        if (!card || !card.live || card.live.liveId !== action.liveId) {
          continue
        }
        card.live.status = action.status
      }
      return newState

    // chatCard
    case types.chatCard.OPEN_BOARD:
      newCard = strToRenjuBoardCard({
        v: 2,
        mv: action.boardContext.mv,
        mk: action.boardContext.mk,
        an: action.boardContext.an,
        tl: action.boardContext.tl,
        bp: action.boardContext.bp,
        wp: action.boardContext.wp,
        gr: action.boardContext.gr
      })
      newCard = {
        ...deepCopy(initialGameAnalyzeCard),
        ...newCard,
        analyzeId: action.analyzeId,
        scale: card.scale,
        settings: {
          ...deepCopy(initialSettings),
          ...newCard.settings,
          ...state.boardSettings,
        },
        gameInfo: {
          ...deepCopy(initialGameInfo),
          ...newCard.gameInfo,
        }
      }
      newCard.live.liveId = action.liveId
      setForbiddenPosition(newCard)
      if (state.cards.some((card) => card.analyzeId === action.analyzeId)) {
        newState.cards = state.cards.map((card, index) => {
          if (card.analyzeId === action.analyzeId) {
            return newCard
          }
          return card
        })
      }
      else {
        newState.cards.push(newCard)
      }
      return newState
    
    case types.renjuBoardCard.OPEN_ANALYZE_TAB:
      newCard = {
        ...deepCopy(card),
        type: constants.boardType.GAME_ANALYZE,
        operationMode: constants.operationModeType.EDIT, 
        analyzeId: 0,
        userType: '',
        live: {
          liveId: card.live.liveId,
        },
        settings: {
          ...deepCopy(initialSettings),
          ...state.boardSettings,
        },
        gameInfo: {
          ...deepCopy(card.gameInfo),
        }
      }
      if (newState.cards.some((card) => card.analyzeId === 0)) {
        newState.cards = newState.cards.map((card) => {
          if (card.analyzeId === 0) {
            return newCard
          }
          return card
        })
      }
      else {
        newState.cards.push(newCard)
      }
      return newState

    // liveGame
    case types.liveGame.CHANGE_TAB:
      if(action.nextBid) {
        newState.cards[action.nextBid].scale = card.scale
      }
      return newState
    
    // puzzleViewer
    case types.puzzleViewer.OPEN:
      if (action.isAnswer) {
        action.record.mv = action.record.as
      }
      action.record.v = 2
      action.record.md = 'p'
      newCard = strToRenjuBoardCard(action.record)
      delete newCard.gameInfo
      delete newCard.settings
      newCard.puzzleInfo.puzzleId = action.record.id

      index = newState.cards.findIndex((card) => 
        card.puzzleInfo &&
        card.puzzleInfo.puzzleId &&
        card.puzzleInfo.puzzleId === action.record.id
      )
      if (index >= 0) {
        if (action.isURL === false) {
          newCard.moves = newCard.moves.filter((move) => move.number === 0)
        }
        newState.cards[index] = {
          ...deepCopy(initialPuzzleViewerCard),
          ...newCard,
          gameInfo: {
            ...deepCopy(initialGameInfo),
            title: action.record.title,
          },
          settings: {
            ...deepCopy(initialSettings),
            ...state.boardSettings
          }
        }
      }
      else {
        newState.cards.push({
          ...deepCopy(initialPuzzleViewerCard),
          ...newCard,
          gameInfo: {
            ...deepCopy(initialGameInfo),
            title: action.record.title,
          },
          settings: {
            ...deepCopy(initialSettings),
            ...state.boardSettings
          }
        })
      }
      resizeBoard(newState)
      return newState
    
    // puzzleRegister
    case types.puzzleRegister.INIT:
      newState.cards = newState.cards.filter(card => card.type !== constants.boardType.PUZZLE_REGISTER)
      newState.cards.push(deepCopy(initialPuzzleRegisterCard))
      return newState

    case types.puzzleRegister.CHANGED_TEXT:
      if (action.name.match(/turn|level|type/)) {
        index = newState.cards.findIndex((c) => c.type === constants.boardType.PUZZLE_REGISTER)
        if (index >= 0) {
          newState.cards[index].puzzleInfo[action.name] = action.text
        }
      }
      return newState

    // fetch
    case types.puzzleViewer.RESPONSE_SELECT_PUZZLE:
    case types.puzzleRegister.RESPONSE_SELECT_PUZZLE:
      if (action.response.result === false || action.response.total !== '1') {
        return state
      }
      record = action.response.records[0]
      record.v = 2
      record.md = 'p'
      if (action.type === types.puzzleRegister.RESPONSE_SELECT_PUZZLE) {
        record.mv = record.as
      }
      newCard = strToRenjuBoardCard(record)
      setForbiddenPosition(newCard)
      delete newCard.gameInfo
      delete newCard.settings
      newCard.puzzleInfo.puzzleId = record.id

      switch (action.type) {
        case types.puzzleViewer.RESPONSE_SELECT_PUZZLE:
          index = newState.cards.findIndex((card) => 
            card.puzzleInfo &&
            card.puzzleInfo.puzzleId &&
            card.puzzleInfo.puzzleId === record.id
          )
          if (index >= 0) {
            newCard.moves = newCard.moves.filter((move) => move.number === 0).concat(newState.cards[index].moves.filter((move) => move.number > 0))
            newState.cards[index] = {
              ...deepCopy(initialPuzzleViewerCard),
              ...newCard,
              puzzleInfo: {
                ...deepCopy(initialPuzzleInfo),
                ...newCard.puzzleInfo,
                title: action.response.records[0].title,
                tags: action.response.records[0].tags,
              },
              settings: {
                ...deepCopy(initialSettings),
                ...state.boardSettings
              }
            }
          }
          else {
            newState.cards.push({
              ...deepCopy(initialPuzzleViewerCard),
              ...newCard,
              puzzleInfo: {
                ...deepCopy(initialPuzzleInfo),
                ...newCard.puzzleInfo,
                title: action.response.records[0].title,
                tags: action.response.records[0].tags,
              },
              settings: {
                ...deepCopy(initialSettings),
                ...state.boardSettings
              }
            })
          }
          resizeBoard(newState)
          break
        case types.puzzleRegister.RESPONSE_SELECT_PUZZLE:
          index = newState.cards.findIndex((card) => card.type === constants.boardType.PUZZLE_REGISTER)
          if (index >= 0) {
            newState.cards[index] = {
              ...deepCopy(initialPuzzleRegisterCard),
              ...newCard,
              puzzleInfo: {
                ...deepCopy(initialPuzzleInfo),
                ...newCard.puzzleInfo,
              },
              settings: {
                ...deepCopy(initialSettings),
                ...state.boardSettings
              }
            }
          }
          break
        default:
          break
      }
      return newState
    
    // controlButtons
    case types.controlButtons.START_PLAY:
      if (card.intervalId >= 0) {
        clearInterval(card.intervalId)
      }
      card.isPlayMode = true
      card.intervalId = action.intervalId
      return newState
    case types.controlButtons.STOP_PLAY:
      card.isPlayMode = false
      clearInterval(card.intervalId)
      card.intervalId = -1
      return newState
    case types.controlButtons.SKIP_PREVIOUS:
      skipPrevious(card)
      return newState
    case types.controlButtons.FAST_REWIND:
      fastRewind(card)
      return newState
    case types.controlButtons.FAST_FORWARD:
      fastForward(card)
      return newState
    case types.controlButtons.SKIP_NEXT:
      skipNext(card)
      return newState

    case types.fetch.user.RESPONSE_SETTINGS:
      {
        if (action.response.result !== true || action.response.settings === undefined) {
          return state
        }
        let { isVisibleNumber, isVisibleNextMove, isVisibleForbidden, isVisibleLastMoveMark } = action.response.settings
        boardSettings = { isVisibleNumber, isVisibleNextMove, isVisibleForbidden, isVisibleLastMoveMark }
        newState.boardSettings = { ...newState.boardSettings, ...deleteUndefinedProps(boardSettings) }
        newState.cards.forEach(card => {
          if (card.type === boardType.GAME_ROOM) {
            return
          }
          card.settings = { ...card.settings, ...boardSettings }
        })
        return newState
      }
    case types.fetch.user.RESPONSE_UPDATE:
      {
        if (action.response.result !== true) {
          return state
        }
        let { isVisibleNumber, isVisibleNextMove, isVisibleForbidden, isVisibleLastMoveMark } = action.response.settings
        boardSettings = { isVisibleNumber, isVisibleNextMove, isVisibleForbidden, isVisibleLastMoveMark }
        newState.boardSettings = { ...newState.boardSettings, ...deleteUndefinedProps(boardSettings)  }
        newState.cards.forEach(card => {
          card.settings = { ...card.settings, ...boardSettings }
          if (boardSettings.isVisibleForbidden === true) {
            setForbiddenPosition(card)
          }
        })
        return newState
      }
    default: 
      return state
  }
}

const resizeBoard = (state) => {
  var element
  state.cards.forEach((card, index) => {
    element = document.getElementById('card-content-' + index)
    if (element) {
      card.cardWidth = element.clientWidth
      card.scale = element.clientWidth < 680 ?
        Math.round(element.clientWidth / 680 * 20) / 20 : 1
    }
    else {
      card.scale = window.innerWidth < 680 ?
        Math.round(window.innerWidth / 680 * 20) / 20 : 1
    }
  })
}

const init = (state, boardType, urlParams, liveId = '') => {
  var newCard, newInitCard, index
  newCard = strToRenjuBoardCard(urlParams)
  setForbiddenPosition(newCard)
  
  switch (boardType) {
    case constants.boardType.WEB_BOARD:
      index = state.cards.findIndex((card) => card.type === constants.boardType.WEB_BOARD)
      state.cards[index] = {
        ...state.cards[index],
        ...newCard,
        puzzleInfo: {
          ...state.cards[index].puzzleInfo,
          ...newCard.puzzleInfo,
        },
        settings: {
          ...state.cards[index].settings,
          ...newCard.settings,
          ...state.boardSettings,
        },
        gameInfo: {
          ...state.cards[index].gameInfo,
          ...newCard.gameInfo,
        }
      }
      break
    case constants.boardType.GAME_ANALYZE:
      newInitCard = deepCopy(initialGameAnalyzeCard)
      state.cards.push({
        ...newInitCard,
        ...newCard,
        operationMode: constants.operationModeType.EDIT, 
        analyzeId: 0,
        userType: '',
        settings: {
          ...newInitCard.settings,
          ...newCard.settings,
          ...state.boardSettings,
        },
        gameInfo: {
          ...newInitCard.gameInfo,
          ...newCard.gameInfo,
        },
        live: {
          liveId,
        }
      })
      break
    default:
      break
  }
}

const xStrings = [ 'a', 'b', 'c' , 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o' ]

const convertMoves = (str) => {
  var strMoves, mvList, x, y
  strMoves = str.split(',')
  mvList = strMoves.map(strMove => {
    if (strMove.length < 2 || strMove.length > 3) {
      return ''
    }
    x = xStrings.findIndex((s) => s === strMove[0])
    if (x < 0) {
      return ''
    }
    y = parseInt(strMove.slice(1, strMove.length), 10)
    if (isNaN(y) || y < 1 || y > 15) {
      return ''
    }
    return x.toString(15) + (15 - y).toString(15)
  })

  return { mv: mvList.join('') }
}

const addMove = (card, move, targetKeys) => {
  var movesBackup
  movesBackup = card.isAnalyzeMode ? card.movesAnalyze : card.movesHistory
  if (movesBackup.length <= card.moves.length) {
    card.moves.push(move)
    movesBackup.push(move)
  }
  else {
    if (targetKeys.every(key => JSON.stringify(movesBackup[card.moves.length][key]) === JSON.stringify(move[key]))) {
      card.moves = card.moves.concat(movesBackup[card.moves.length])
    }
    else {
      card.moves.push(move)
      movesBackup = card.moves.slice(0, card.moves.length)
    }
  }
  card.movesAnalyze = card.isAnalyzeMode === true ? deepCopy(movesBackup) : card.movesAnalyze
  card.movesHistory = card.isAnalyzeMode === false ? deepCopy(movesBackup) : card.movesHistory
  setOpeningRuleProps(card)
}

const setOpeningRuleProps = (card) => {
  var movesBackup
  card.gameInfo.soosyrv8 = { swap1: undefined, swap2: undefined, fiveMoveNumber: 0, fiveMoves: [] }
  movesBackup = card.isAnalyzeMode ? card.movesAnalyze : card.movesHistory
  switch (card.gameInfo.openingRule) {
    case constants.OPENING_RULE.SOOSYRV8:
      movesBackup.forEach((mb, index) => {
        if (index === 4) {
          card.gameInfo.soosyrv8.swap1 = mb.swap
        }
        else if (index === 6) {
          card.gameInfo.soosyrv8.fiveMoveNumber = mb.fiveMoveNumber
        }
        else if (index === 7) {
          card.gameInfo.soosyrv8.swap2 = mb.swap
        }
        else if (index === 8) {
          card.gameInfo.soosyrv8.fiveMoves = deepCopy(mb.fiveMoves)
        }
      })
      break
    default:
      break
  }
}

const clickRenjuBoard = ( bid, event, card ) => {
  var element, scale, coordinateWidth, cell, clientRect, positionX, positionY, x, y
  var { editMode } = card
  element = document.getElementById("renjuboard" + bid)
  scale = element.clientWidth / 680
  coordinateWidth = 40 * scale;
  cell = 40 * scale;
  clientRect = element.getBoundingClientRect();
  positionX = event.pageX - clientRect.left - window.pageXOffset - coordinateWidth
  positionY = event.pageY - clientRect.top - window.pageYOffset - coordinateWidth
  x = parseInt(positionX / cell, 10);
  y = parseInt(positionY / cell, 10);
  if (x > 14 || x < 0 || y > 14 || y < 0 || positionX < 0 || positionY < 0) {
    return
  }

  switch(editMode) {
    case constants.editModeType.NORMAL:
      clickRenjuBoardForNormal(card, x, y)
      break
    case constants.editModeType.PUZZLE:
      clickRenjuBoardForPuzzle(card, x, y)
      break 
    default:
      break
  }

  setForbiddenPosition(card)
}

const clickRenjuBoardForNormal = (card, x, y) => {
  var move, color, number
  var { operationMode, isMarkMode, isPlayMode, moves, puzzleInfo } = card
  if (operationMode === constants.operationModeType.VIEW || isPlayMode){
    fastForward(card)
    return
  }

  if (moves.some(move => move.x === x && move.y === y)) {
    return
  }

  if (isMarkMode) {
    move = moves[moves.length - 1];
    if (move.insertStrings.length <= 0 ) {
      return
    }
    if (move.marks.some((mark) => mark.x === x && mark.y === y)) {
      move.marks = move.marks.filter((mark) => {
        if (mark.x === x && mark.y === y) {
          move.insertStrings = mark.str + move.insertStrings
          return false
        }
        return true
      })
    }
    else { 
      move.marks = move.marks.concat({x: x, y : y, str: move.insertStrings.slice(0, 1)})
      move.insertStrings = move.insertStrings.slice(1, move.insertStrings.length)
    }
    return
  }

  number = Math.max(...moves.map(move => move.number)) + 1
  if (operationMode === constants.operationModeType.SET) {
    switch (puzzleInfo.turn) {
      case constants.turnType.BLACK:
        color = 0 === number % 2 ? 'white' : 'black'
        break
      case constants.turnType.WHITE:
        color = 0 === number % 2 ? 'black' : 'white'
        break
      default:
        color = 0 === number % 2 ? 'white' : 'black'
        break
    }
  }
  else {
    color = 0 === number % 2 ? 'white' : 'black'
  }

  if (card.editMode === constants.editModeType.NORMAL && card.gameInfo) {
    switch (card.gameInfo.openingRule) {
      case constants.OPENING_RULE.NONE:
        break
      case constants.OPENING_RULE.FREE:
        if (number === 1 && (x !== 7 || y !== 7)) {
          return
        }
        if (number === 2 && (x <= 5 || x >= 9 || y <= 5 || y >= 9)) {
          return
        }
        if (number === 3 && (x <= 4 || x >= 10 || y <= 4 || y >= 10)) {
          return
        }
        break
      case constants.OPENING_RULE.SOOSYRV8:
        if (number === 1 && (x !== 7 || y !== 7)) {
          return
        }
        if (number === 2 && (x <= 5 || x >= 9 || y <= 5 || y >= 9)) {
          return
        }
        if (number === 3 && (x <= 4 || x >= 10 || y <= 4 || y >= 10)) {
          return
        }
        if (card.moves.length === 4) {
          card.message.visible = true
          card.message.type = constants.renjuBoardMessageType.SWAP1
          return
        }
        if (card.moves.length === 6) {
          card.message.visible = true
          card.message.type = constants.renjuBoardMessageType.FIVE_MOVE_NUMBER
          return
        }
        if (card.moves.length === 7) {
          card.message.visible = true
          card.message.type = constants.renjuBoardMessageType.SWAP2
          return
        }
        if (card.moves.length === 8) {
          let fiveMoves = card.gameInfo.soosyrv8.fiveMoves
          if (fiveMoves.some(move => move.x === x && move.y === y)){
            card.gameInfo.soosyrv8.fiveMoves = fiveMoves.filter(move => !(move.x === x && move.y === y))
            return
          }
          if (fiveMoves.length >= card.gameInfo.soosyrv8.fiveMoveNumber) {
            card.message.visible = true
            card.message.type = constants.renjuBoardMessageType.FIVE_MOVES
            return
          }
          let validator, invalidFiveMoves
          validator = new FiveMovesValidator()
          validator.setMoves(card.moves, card.gameInfo.soosyrv8.fiveMoves.concat({ x, y }))
          invalidFiveMoves = validator.getInvalidFiveMoves()
          card.gameInfo.soosyrv8.fiveMoves = card.gameInfo.soosyrv8.fiveMoves.filter(move => {
            return invalidFiveMoves.some(mv => move.x === mv.x && move.y === mv.y) === false
          })
          card.gameInfo.soosyrv8.fiveMoves.push({ x, y })
          return
        }
        if (card.moves.length === 9) {
          let fiveMoves = card.gameInfo.soosyrv8.fiveMoves
          if (fiveMoves.every(move => move.x !== x || move.y !== y)) {
            return
          }
        }
        break
      default:
        break
    }
  }
  addMove(card, { x, y, color, number, marks: [], insertStrings: defaultInsertStrings }, ['x', 'y', 'color'])
  return
}

const clickRenjuBoardForPuzzle  = (card, x, y) => {
  var newMoves
  var { operationMode, isMarkMode, moves } = card

  switch (operationMode) {
    case constants.operationModeType.EDIT:
      if (isMarkMode) {
        if (moves.some((move) => move.x === x && move.y === y)) {
          card.moves = card.moves.filter((move) => !(move.x === x && move.y === y))
        }
        if (card.moves[0].marks.some((mark) => mark.x === x && mark.y === y)) {
          card.moves[0].marks = card.moves[0].marks.filter((mark) => {
            if (mark.x === x && mark.y === y) {
              card.moves[0].insertStrings = mark.str + card.moves[0].insertStrings
              return false
            }
            return true
          })
        }
        else if (card.moves[0].insertStrings.length > 0 ) {
          card.moves[0].marks = moves[0].marks.concat({x: x, y : y, str: moves[0].insertStrings.slice(0, 1)})
          card.moves[0].insertStrings = moves[0].insertStrings.slice(1, moves[0].insertStrings.length)
        }
      }
      else {
        if (card.moves[0].marks.some((mark) => mark.x === x && mark.y === y)) {
          card.moves[0].marks = card.moves[0].marks.filter((mark) => {
            if (mark.x === x && mark.y === y) {
              card.moves[0].insertStrings = mark.str + card.moves[0].insertStrings
              return false
            }
            return true
          })
        }
        if (moves.some((move) => move.x === x && move.y === y && move.color === card.puzzleInfo.stoneType)) {
          newMoves = moves.filter((move) => !(move.x === x && move.y === y && move.color === card.puzzleInfo.stoneType))
        }
        else if (moves.some((move) => move.x === x && move.y === y && move.color !== card.puzzleInfo.stoneType)) {
          newMoves = moves.filter((move) => !(move.x === x && move.y === y && move.color !== card.puzzleInfo.stoneType))
          newMoves = newMoves.concat({x: x, y: y, color: card.puzzleInfo.stoneType, number: 0, marks: [], insertStrings: defaultInsertStrings})
        }
        else {
          newMoves = moves.concat({x: x, y: y, color: card.puzzleInfo.stoneType, number: 0, marks: [], insertStrings: defaultInsertStrings})
        }
        card.moves = newMoves
      }
      break
    case constants.operationModeType.SET:
      clickRenjuBoardForNormal(card, x, y)
      break
    default:
      break
  }
}

const rightClickRenjuBoard = ( bid, event, card ) => {
  var { editMode, operationMode, isAnalyzeMode, isMarkMode, moves, analyzeStartNum } = card
  var num

  if (isMarkMode && operationMode !== constants.operationModeType.VIEW){
    removeMark(card)
    return
  }
  else if (
    editMode === constants.editModeType.PUZZLE &&
    operationMode === constants.operationModeType.EDIT
  ) {
    if (moves.length > 1) {
      moves.pop()
    }
    setForbiddenPosition(card)
    return
  }

  num = moves.filter((move) => move.number !== 0).length
  if ((isAnalyzeMode && num - analyzeStartNum > 0) ||
      (!isAnalyzeMode && num > 0))
  {
    moves.pop()
  }
  setForbiddenPosition(card)
}

const setForbiddenPosition = (card) => {
  if (card.settings && card.settings.isVisibleForbidden === false) {
    return
  }
  var engine = new RenjuEngine()
  engine.setMoves(card.moves)
  engine.checkLine()
  card.forbiddenPosition = engine.getForbiddenPosition()
}

const removeMark = (card) => {
  var { moves, editMode, operationMode } = card
  var move
  if (
    editMode === constants.editModeType.PUZZLE &&
    operationMode === constants.operationModeType.EDIT
  ) {
    move = moves[0]
  }
  else {
    move = moves[moves.length - 1]
  }
  if (move.marks.length > 0){
    var mark = move.marks.pop();
    move.insertStrings = mark.str + move.insertStrings;
  }
}

const skipPrevious = (card) => {
  var { analyzeStartNum, isAnalyzeMode } = card
  switch(card.editMode) {
    case constants.editModeType.NORMAL:
      if (isAnalyzeMode){
        card.moves = card.moves.filter((move, index) => index < analyzeStartNum + 1)
      }
      else {
        card.moves = card.moves.filter((move, index) => index === 0)
      }
      break
    case constants.editModeType.PUZZLE:
      card.moves = card.moves.filter((move) => move.number === 0)
      break
    default:
      break
  }
  setForbiddenPosition(card)
}

const fastRewind = (card) => {
  if (card.moves.filter((move, index) => index !== 0).length > 0) {
    card.moves.pop()
  }
  setForbiddenPosition(card)
}

const fastForward = (card) => {
  var { isAnalyzeMode, intervalId, moves, movesAnalyze, movesHistory } = card
  var movesBackup
  movesBackup = isAnalyzeMode ? movesAnalyze : movesHistory
  if (movesBackup.length > moves.length){
    if (0 <= intervalId && movesBackup.length === moves.length + 1) {
      clearInterval(intervalId);
      card.isPlayMode = false
      card.intervalId = -1
    }
    card.moves = moves.concat(movesBackup[moves.length])
  }
  setOpeningRuleProps(card)
  setForbiddenPosition(card)
}

const skipNext = (card) => {
  var { isAnalyzeMode, movesAnalyze, movesHistory, intervalId } = card
  var movesBackup
  movesBackup = isAnalyzeMode ? movesAnalyze : movesHistory
  card.moves = movesBackup.slice(0, movesBackup.length)
  if (0 <= intervalId) {
    clearInterval(intervalId)
  }
  setOpeningRuleProps(card)
  setForbiddenPosition(card)

  card.isPlayMode = false
  card.intervalId = -1
}

export default RenjuBoardCards


// WEBPACK FOOTER //
// ./src/reducers/Common/RenjuBoardCard/RenjuBoardCards.js